import React, { Component } from 'react';
import styles from './app.css';

class App extends Component {
    
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="regisDesignContent" className={styles.content}>
        {this.props.children}
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/views/App/App.js